import { LessonTaskStepKey } from '../../../main/types/asset/lesson.types.ts';

export const PROGRESS_SLICE_NAME = 'progress';

export interface ProgressSliceState {
  lastCompletedStep?: LessonTaskStepKey;
  lastCompletedStepTemp?: LessonTaskStepKey;
}
